import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-expired-page',
  templateUrl: './expired-page.component.html',
  styleUrls: ['./expired-page.component.css']
})
export class ExpiredPageComponent implements OnInit {

  schemaCode: string;
  constructor( private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.schemaCode = params.schemaCode;
    });
   }

  ngOnInit(): void {
  }

}
